import { gql } from 'graphql-request';

export interface IntrospectInfo {
  tokenIsValid: boolean;
  ecomToken?: string;
}

interface IntrospectData {
  data: IntrospectInfo;
}

interface IntrospectResult {
  result: IntrospectData;
}

export interface IntrospectResponse {
  wEcomIntrospect: IntrospectResult;
}

export const INTROSPECT = gql`
  query wEcomIntrospect($token: String!, $ecomToken: String, $idToken: String) {
    wEcomIntrospect(token: $token, ecomToken: $ecomToken, idToken: $idToken)
  }
`;
